<template>
    <div
        class="min-h-screen flex flex-col max-w-[600px] mx-auto"
        style="background:#F5F5F7;font-family:'DM Sans',system-ui,sans-serif;"
    >

        <!-- ── OVERLAY SYNC ─────────────────────────────────── -->
        <transition name="tf-fade">
            <div
                v-if="loadingSaveData"
                class="fixed inset-0 z-50 flex items-center justify-center"
                style="background:rgba(245,245,247,0.85);backdrop-filter:blur(16px);"
            >
                <div class="flex flex-col items-center gap-4">
                    <span class="tf-loader-template"></span>
                    <div class="flex flex-col items-center gap-0.5">
                        <span class="tf-loader-template-label">
                            Mise à jour<span class="tf-dot">.</span><span class="tf-dot">.</span><span class="tf-dot">.</span>
                        </span>
                        <span style="font-size:11px;color:#AAAAB8;font-weight:500;">Synchronisation des données</span>
                    </div>
                </div>
            </div>
        </transition>

        <!-- ── CONTENT ──────────────────────────────────────── -->
        <main
            class="flex-1 overflow-y-auto bg-gray-50"
            style="padding-bottom:calc(90px + env(safe-area-inset-bottom, 0px));"
        >
            <slot />
        </main>

        <!-- ── BOTTOM NAV ───────────────────────────────────── -->
        <nav
            class="max-w-[600px] mx-auto fixed bottom-0 inset-x-0 z-30 px-4 mb-5"
            :style="`padding-bottom: env(safe-area-inset-bottom, 12px);`"
        >
            <div
                class="flex items-center h-[64px] rounded-3xl px-2 gap-1"
                style="background:rgba(255,255,255,0.96);backdrop-filter:blur(24px) saturate(180%);box-shadow:0 4px 42px rgba(0,0,0,0.10),0 1px 0 rgba(0,0,0,0.04),inset 0 1px 0 rgba(255,255,255,0.8);"
            >
                <!-- Tab : Planning -->
                <button class="tf-tab" :class="{'tf-tab--active':activeIndex===0}" @click="select(0)">
                    <span class="tf-tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="3"/>
                            <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
                            <line x1="3" y1="10" x2="21" y2="10"/>
                            <path d="M8 14h.01M12 14h.01M8 17h.01M12 17h.01M16 17h.01"/>
                        </svg>
                    </span>
                    <span class="tf-tab-label">Planning</span>
                </button>

                <!-- Tab : Stock -->
                <button class="tf-tab" :class="{'tf-tab--active':activeIndex===1}" @click="select(1)">
                    <span class="tf-tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
                            <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                            <line x1="12" y1="22.08" x2="12" y2="12"/>
                        </svg>
                    </span>
                    <span class="tf-tab-label">Stock</span>
                </button>

                <!-- ── BOUTON CENTRAL ── -->
                <div class="flex-1 flex items-center justify-center">
                    <button
                        class="w-[52px] h-[52px] rounded-2xl flex items-center justify-center transition-transform active:scale-90 rounded-full"
                        style="background:linear-gradient(145deg,#FF7A3D,#FF5F1F);box-shadow:0 8px 20px rgba(255,95,31,0.40),0 2px 6px rgba(255,95,31,0.25),inset 0 1px 0 rgba(255,255,255,0.18);"
                        @click="select(2)"
                    >
                        <svg
                            width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white"
                            stroke-width="2.2" stroke-linecap="round"
                            :style="activeIndex===2 ? 'transform:rotate(45deg)' : ''"
                            style="transition:transform .2s cubic-bezier(.4,0,.2,1);"
                        >
                            <path d="M12 5v14M5 12h14"/>
                        </svg>
                    </button>
                </div>

                <!-- Tab : Stats -->
                <button class="tf-tab" :class="{'tf-tab--active':activeIndex===3}" @click="select(3)">
                    <span class="tf-tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="3" width="20" height="14" rx="2"/>
                            <line x1="8" y1="21" x2="16" y2="21"/>
                            <line x1="12" y1="17" x2="12" y2="21"/>
                        </svg>
                    </span>
                    <span class="tf-tab-label">Bureau</span>
                </button>

                <!-- Tab : Profil -->
                <button class="tf-tab" :class="{'tf-tab--active':activeIndex===4}" @click="select(4)">
                    <span class="tf-tab-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="7" r="4"/>
                            <path d="M4 20c0-4 3.58-7 8-7s8 3 8 7"/>
                        </svg>
                    </span>
                    <span class="tf-tab-label">{{ $account.account.prenom }}</span>
                </button>
            </div>
        </nav>

    </div>
</template>

<script>
export default {
    name: 'AppLayout',

    props: {
        title:        { type: String, default: 'Termoflow' },
        subtitle:     { type: String, default: 'Chauffage & Climatisation' },
        initialRoute: { type: String, default: '/' },
    },

    data() {
        return {
            activeIndex: 0,
            tabs: [
                { id: 'planning',     route: '/'                            },
                { id: 'stock',        route: '/stock-mobile'                       },
                { id: 'intervention', route: '/app/widget/new-intervention' },
                { id: 'stats',        route: '/stats-mobile'                       },
                { id: 'profil',       route: '/profil'                      },
            ],
            loadingSaveData: false,
        }
    },

    created() {
        const path = this.$route?.path || this.initialRoute
        const i = this.tabs.findIndex(t => t.route === path)
        if (i >= 0) this.activeIndex = i
    },

    mounted() {
        if (this.$account.account.societe.date_licence) {
            const now = new Date()
            const date_licence = new Date(this.$account.account.societe.date_licence)
            if (date_licence < now) {
                if (this.$router) this.$router.push('/app/licence-expired').catch(() => {})
                else window.location.href = '/app/licence-expired'
                return
            }
        }

        if (!this.$account.account.signature) {
            window.location.href = '/add-signature'
            return
        }

        this.loadData()
    },

    methods: {
        select(i) {
            this.activeIndex = i
            const route = this.tabs[i].route
            if (this.$router) this.$router.push(route).catch(() => {})
            else window.location.href = route

            if (i === 2 && this.$route.path == '/app/widget/new-intervention') {
                this.$eventHub.$emit('reset-chantier-init')
            }
        },

        async loadData() {
            const lastVersionSaved   = localStorage.getItem('mobileVersionSaved')
            const lastVersionSociete = this.$account.account.societe.mobile_version_storage
            if (!lastVersionSaved || !lastVersionSociete || lastVersionSaved != lastVersionSociete) {
                this.loadingSaveData = true
                try {
                    const [pointsControle, travaux, categorieAppareil] = await Promise.all([
                        this.$request.get('/mobile/maj/points-controles'),
                        this.$request.get('/mobile/maj/travaux'),
                        this.$request.get('/mobile/maj/categorie-appareils'),
                    ])
                    localStorage.setItem('mobilePointsControle',   JSON.stringify(pointsControle))
                    localStorage.setItem('mobileTravaux',           JSON.stringify(travaux))
                    localStorage.setItem('mobileCategorieAppareil', JSON.stringify(categorieAppareil))
                    localStorage.setItem('mobileVersionSaved',      lastVersionSociete)
                } finally {
                    this.loadingSaveData = false
                }
            }
        },
    },
}
</script>

<style scoped>
.tf-tab {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    border: none;
    background: transparent;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    outline: none;
    padding: 0;
    min-width: 0;
    height: 100%;
}

.tf-tab-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 28px;
    border-radius: 10px;
    transition: background .18s, color .18s;
    color: #C4C4CE;
}

.tf-tab--active .tf-tab-icon {
    background: rgba(255, 95, 31, 0.10);
    color: #FF5F1F;
}

.tf-tab-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: .1px;
    color: #C4C4CE;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 56px;
    transition: color .15s;
    line-height: 1;
}

.tf-tab--active .tf-tab-label {
    color: #FF5F1F;
}

/* ── Spinner ── */
.tf-loader-template {
    display: block;
    width: 52px; height: 52px;
    border-radius: 50%;
    background: conic-gradient(from 0deg, #FFAA5A 0%, #FF5F1F 45%, #ff3a00 70%, transparent 100%);
    position: relative;
    animation: tf-spin 1s cubic-bezier(0.4,0,0.6,1) infinite;
}
.tf-loader-template::before {
    content: "";
    position: absolute;
    inset: 7px;
    border-radius: 50%;
    background: #F5F5F7;
}
@keyframes tf-spin { to { transform: rotate(360deg); } }

.tf-loader-template-label {
    font-size: 14px;
    font-weight: 700;
    color: #1a1a24;
}

.tf-dot { display: inline-block; animation: tf-blink 1.4s infinite; }
.tf-dot:nth-child(2) { animation-delay: .2s; }
.tf-dot:nth-child(3) { animation-delay: .4s; }
@keyframes tf-blink {
    0%, 80%, 100% { opacity: 0.2; }
    40% { opacity: 1; }
}

.tf-fade-enter-active, .tf-fade-leave-active { transition: opacity .2s ease; }
.tf-fade-enter, .tf-fade-leave-to { opacity: 0; }
</style>